import Link from "next/link";
import { ModuleTwoUp } from "@/components/module";
import MarketplaceGallery from "@/components/home/marketplace_gallery";
import CircleCheckmarkIcon from "@/components/icons/circle_checkmark";
import MicroscropeIcon from "@/components/icons/microscope";

function SupplierFooter() {
  return (
    <footer>
      <p>
        Are you a carbon removal company interested in working with Watershed?{" "}
        <a href="mailto:marketplace@watershed.com">Let us know ›</a>
      </p>
      <style jsx>{`
        footer {
          grid-column: -1 / 1;
          text-align: center;
          padding: 16px;
          line-height: 1.375;
        }
        p {
          font-size: 14px;
          margin: auto;
        }
        a {
          color: #265cff;
          font-weight: bold;
          white-space: nowrap;
        }
        @media (min-width: 520px) {
          footer {
            padding: 24px 16px;
            border-top: 1px solid #edf1f5;
          }
          p {
            font-size: unset;
          }
        }
      `}</style>
    </footer>
  );
}

export default function MarketplaceModule() {
  return (
    <ModuleTwoUp
      headline="High-quality carbon removal through the Watershed Marketplace"
      id="marketplace"
      graphic={
        <>
          <div
            style={{
              alignSelf: "center",
              justifySelf: "center",
              maxWidth: "100%",
              margin: "auto",
            }}
          >
            <MarketplaceGallery />
          </div>
          <SupplierFooter />
        </>
      }
    >
      <div>
        <p>
          Invest in cutting-edge{" "}
          <Link href="/blog/carbon-removal-and-offsets-a-buyers-guide">
            carbon removal and high-quality carbon offsets
          </Link>
          , right from the Watershed dashboard. We work directly with a roster
          of innovative partners, so your funds make the largest impact.
        </p>
        <ul className="features-grid">
          <li>
            <MicroscropeIcon />
            <span>
              Get access to frontier carbon removal technologies, helping build
              the market for cutting-edge solutions while permanently removing
              carbon from the atmosphere.
            </span>
          </li>
          <li>
            <CircleCheckmarkIcon />
            All projects are fully vetted by the Watershed team to ensure
            they’re driving real impact.
          </li>
        </ul>
      </div>
      <style jsx>{`
        .features-grid {
          padding: 0;
          list-style: none;
          margin-top: 24px;
        }
        .features-grid li {
          display: flex;
          margin-top: 24px;
        }
        .features-grid li :global(svg) {
          width: 56px;
          height: 56px;
          fill: #5f6575;
          margin-right: 16px;
          flex-shrink: 0;
        }
      `}</style>
    </ModuleTwoUp>
  );
}
